import { render, staticRenderFns } from "./YourAdviser.vue?vue&type=template&id=5ada7f20&"
import script from "./YourAdviser.vue?vue&type=script&lang=js&"
export * from "./YourAdviser.vue?vue&type=script&lang=js&"
import style0 from "./YourAdviser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports